(function () {
    if (typeof window !== 'undefined') {
        require('smoothscroll-polyfill').polyfill();
    }
})();
